import React, { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import DownloadButton from './../../components/Buttons/DownloadButton';
import { useAuth } from './../../context/AuthContext';
import getBaseUrl from './../../utils/baseUrl';
import { useFlow } from './../../context/FlowContext';
import BackButton from './../BackButton.jsx';
import useAndroidBody  from './../hooks/useAndroidBody.js';

const fetchGuideHtml = async (fileName) => {
  const res = await fetch(`${getBaseUrl()}/guides/android/${fileName}`);
  if (!res.ok) throw new Error(`Failed to fetch ${fileName}`);
  const text = await res.text();
  return DOMPurify.sanitize(text);
};

export default function FinalChecks() {
  useAndroidBody();
  const { androidApk } = useAuth();
  const { finalVisorId } = useFlow();
  const [html, setHtml] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const c = await fetchGuideHtml('FinalChecks.html');
        setHtml(c);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="android-install ai-wrap">
      <header className="ai-header"><div className="ai-header__title"><span>Final checks</span></div></header>
      <main className="ai-main">
        <section className="card">
          <BackButton />
          <div className="muted" style={{ marginBottom: 8 }}>Device ID: <strong>{finalVisorId}</strong></div>
          {loading ? <div className="skeleton"><div className="skeleton__line"/></div>
                   : <div className="html-content" dangerouslySetInnerHTML={{ __html: html }} />}

          <DownloadButton className="btn btn--block btn--accent" link={androidApk} title="Download eSafe APK" />
        </section>
      </main>
    </div>
  );
}
